import { Modal, ModalFooter, ModalHeader } from "reactstrap";
import CustomHeader from "./CustomHeader";

interface ModalCreateProps {
    title: string;
    show?: boolean;
    handle?: () => void;
    children?: React.ReactNode;
    footer?: React.ReactNode;
}

const ModalCreate = ({
                         title,
                         show,
                         handle,
                         children,
                         footer
                     }: ModalCreateProps) => {
    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();

                const submitButton = document.querySelector('#add-btn') as HTMLButtonElement;

                if (submitButton && submitButton.form) {
                    submitButton.form.requestSubmit();
                }
            }}
        >
            <Modal
                isOpen={show}
                centered
                size="md"
                backdrop="static"
                fade
                className="border-0"
                modalClassName="modal-dialog-centered"
                contentClassName="border-0 rounded-4 shadow overflow-hidden"
            >
                <CustomHeader title={title} onClose={handle} component={ModalHeader} />

                {/* BODY */}
                <div
                    className="modal-body px-4 py-4"
                    style={{
                        maxHeight: 'calc(100vh - 220px)',
                        overflowY: 'auto'
                    }}
                >
                    {children}
                </div>

                {/* FOOTER */}
                {footer && (
                    <ModalFooter
                        className="px-4 py-3 border-top"
                    >
                        {footer}
                    </ModalFooter>
                )}
            </Modal>
        </form>
    );
};

export default ModalCreate;
